export enum FitContent {
    None = 'none',
    Contain = 'contain',
    Cover = 'cover',
    Fill = 'fill',
    ScaleDown = 'scale-down'
}
